import Axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { api } from './api.config';

export type ErrorType<Error> = AxiosError<Error>;

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: { signal?: AbortSignal }
): Promise<T> => {
  const source = Axios.CancelToken.source();
  let onAbort: (() => void) | undefined;

  if (options?.signal) {
    if (options.signal.aborted) {
      source.cancel('Query was cancelled');
    } else {
      onAbort = () => source.cancel('Query was cancelled');
      options.signal.addEventListener('abort', onAbort, { once: true });
    }
  }

  return api({
    ...config,
    cancelToken: source.token,
  })
    .then(({ data }) => data)
    .finally(() => {
      if (onAbort && options?.signal) {
        options.signal.removeEventListener('abort', onAbort);
      }
    });
};

export default customInstance;
